export default "__VITE_ASSET__o4Uht56H__"